/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./Cn.css";
import { Link, Redirect } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";
import { DONOR_AUTH, ORG_AUTH, PLATFORM } from "../../config";
import { checkLoginStatus } from "../../assets/helper";
import PlugCn from "../PlugCn/PlugCn";

class Cn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    // Platform conditional rendering. On Plug the homepage is the marketing
    // site, not the marketplace — the marketplace is where its sign-up and
    // "Browse nonprofits" buttons lead, at /webapp (CP-318).
    //
    // Except for a session that is already signed in. This path used to render
    // the marketplace, which opens the workspace an org or donor belongs to;
    // handing them marketing copy and a "Log in" button instead loses them the
    // way back to their own dashboard. The site keeps its own paths (/PlugEn
    // and friends), so it is still readable while signed in.
    if (PLATFORM === "plug") {
      if (checkLoginStatus(ORG_AUTH) || checkLoginStatus(DONOR_AUTH)) {
        return <Redirect to="/webapp" />;
      }
      return <PlugCn {...this.props} />;
    }

    // Existing CheckPlus implementation
    return (
      <div className="Cn-view">
        <Helmet>
          <title>CheckPlus</title>
        </Helmet>

        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}

        {renderHomePageHeader(this)}

        <div className="Cn-first">
          <div className="Cn-firstContainer">
            <div className="Cn-first-content">
              <div className="Cn-first-picture" />
              <div className="Cn-first-text">
                <div className="Cn-heading">机构自动化</div>

                <div className="Cn-noteTxt">
                  属香港《税务条例》第88条的免税非牟利机构才可使用 CheckPlus for
                  Nonprofits。
                </div>

                <Link to="/CnVideo">
                  <div className="Cn-supportOrgNextContainer">
                    <div className="Cn-supportOrgNextText">观看影片</div>
                    <div className="Cn-supportOrgNextArrow" />
                  </div>
                </Link>
              </div>

              <div className="Cn-awardsOuterContainer">
                <div className="Cn-trophyContainer">
                  <div className="Cn-trophyIcn" />
                  <div className="Cn-trophyTxt">奖项</div>
                </div>
                <div className="Cn-awards" />
              </div>

              <div className="Cn-awardsOuterContainer">
                <div className="Cn-trophyContainer">
                  <div className="Cn-pressIcn" />
                  <div className="Cn-pressTxt">媒体报导</div>
                </div>
                <div className="Cn-newspaperContainer">
                  <div className="Cn-hkej" />
                  <div className="Cn-ejtech" />
                  <div className="Cn-hktkww" />
                  <div className="Cn-wenweipo" />
                </div>
                <div className="Cn-newspaperContainer">
                  <div className="Cn-oncc" />
                  <div className="Cn-techapple" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="Cn-organizationPage">
          <div className="Cn-nonprofitContainer">
            <div className="Cn-nonprofitCircle">
              <div className="Cn-nonprofitIcn" />
            </div>
            <div className="Cn-nonprofitTxt">非牟利机构</div>
          </div>

          <div className="Cn-orgText">多间非牟利机构已经使用 CheckPlus</div>
          <div className="Cn-organizations">
            <a
              href="https://cbnhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-cbnhk" />
            </a>

            <a
              href="https://peacemaker.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-peacemaker" />
            </a>

            <a
              href="https://bbhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-bbhk" />
            </a>

            <a
              href="https://lovefoundation.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-LF" />
            </a>

            <a
              href="https://cchchk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-cchchk" />
            </a>

            <a
              href="https://charactercity.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-charactercity" />
            </a>

            <a
              href="https://sunriseministry.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-sunriseministry" />
            </a>

            <a
              href="https://sunrisechurch.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-sunrisechurch" />
            </a>

            <a
              href="https://gnci.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-gnci" />
            </a>

            <a
              href="https://networkj.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-networkj" />
            </a>

            <a
              href="https://emmhk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-emmhk" />
            </a>

            <a
              href="https://gfy.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-gfy" />
            </a>

            <a
              href="https://echovalley.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-echovalley" />
            </a>

            <a
              href="https://godsglory.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-godsglory" />
            </a>

            <a
              href="https://nav2000hk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-nav2000hk" />
            </a>

            <a
              href="https://gcchk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-gcchk" />
            </a>

            <a
              href="https://petrosbookroom.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-alo" />
            </a>

            <a
              href="https://elijahmission.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-elijahmission" />
            </a>

            <a
              href="https://4limb.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-direction" />
            </a>

            <a
              href="https://rcsahk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-rcsahk" />
            </a>

            <a
              href="https://ebs.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-ebs" />
            </a>

            <a
              href="https://raphahk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-raphahk" />
            </a>

            <a
              href="https://livinghopeworld.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-livinghope" />
            </a>

            <a
              href="https://footprintgallery.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-footprint" />
            </a>

            <a
              href="https://alayluya.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-alayluya" />
            </a>

            <a
              href="https://crownfinancial.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-crownhk" />
            </a>

            <a
              href="https://psyreligion.check.plus"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-capr" />
            </a>

            <a
              href="https://ecohk.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-eco" />
            </a>

            <a
              href="https://senrights.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-senrights" />
            </a>

            <a
              href="https://nytec.check.plus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="Cn-frame Cn-nytec" />
            </a>
          </div>
        </div>

        <div className="Cn-orgText">主要功能</div>

        <div className="Cn-mouseContainer">
          <div className="Cn-mouseIcn" />
          <div className="Cn-mouseTxt">向左或向右卷动</div>
        </div>

        <div className="Cn-third">
          <div className="Cn-third-space" />
          <div className="Cn-thirdContainer">
            <div className="Cn-third-text-Container">
              <div className="Cn-iconWithtext">
                <div className="Cn-third-firstIcnContainer">
                  <div className="Cn-second-firstIcn" />
                </div>

                <div className="Cn-third-brandText">建立捐款网页</div>
              </div>

              <div className="Cn-third-description">
                透过 CheckPlus，系统会自动为阁下的机构准备一个捐款网页。
              </div>
            </div>

            <div className="Cn-third-iphone" />
          </div>
          <div className="Cn-thirdContainer">
            <div className="Cn-third-text-Container">
              <div className="Cn-iconWithtext">
                <div className="Cn-fourth-secondIcnContainer">
                  <div className="Cn-second-secondIcn" />
                </div>
                <div className="Cn-third-brandText">多个捐款项目</div>
              </div>

              <div className="Cn-third-description">
                机构可以建立多个筹款项目，还可以轻松地为其项目设置筹款目标。
              </div>
            </div>

            <div className="Cn-fourth-iphone" />
          </div>
          <div className="Cn-transaction-type-container ">
            <div className="Cn-transaction-type-top">
              <div className="Cn-donation-payment-switch" />
            </div>
            <div className="Cn-transaction-type-text-container">
              <div className="Cn-donation-payment-icons" />
              <div className="Cn-transaction-type-text">设定付款或捐款类型</div>

              <div className="Cn-transaction-type-description">
                機構可以設定付款或捐款類型，以確保系統自動發出正確合規格的收據。
              </div>
            </div>
          </div>
          <div className="Cn-accept-networks-container">
            <div className="Cn-cardIcn-circle">
              <div className="Cn-cardIcn" />
            </div>
            <div className="Cn-cardTxt">接受多个付款方式</div>

            <div className="Cn-third-text-Container">
              <div className="Cn-networkList">
                <div className="Cn-paymentRow1">
                  <div className="Cn-visaIcon" />
                  <div className="Cn-mastercardIcon" />
                  <div className="Cn-amexIcon" />
                  <div className="Cn-unionpayIcon" />
                </div>
                <div className="Cn-paymentRow2">
                  <div className="Cn-applePay" />
                  <div className="Cn-googlePay" />
                  <div className="Cn-payme" />
                </div>
              </div>
            </div>
          </div>
          <div className="Cn-thirdContainer">
            <div className="Cn-third-text-Container">
              <div className="Cn-iconWithtext">
                <div className="Cn-sixth-fourthIcnContainer">
                  <div className="Cn-second-fourthIcn" />
                </div>

                <div className="Cn-third-brandText">支援每月定期捐款</div>
              </div>

              <div className="Cn-third-description">
                捐款者可以自行透过捐款网页安排每月定期捐款，他们还可以自行更新的已安排捐款。
                (仅适用于已注册帐户的捐款者)
              </div>
            </div>

            <div className="Cn-frequency" />
          </div>
          <div className="Cn-thirdContainer">
            <div className="Cn-third-text-Container">
              <div className="Cn-iconWithtext-noDescription">
                <div className="Cn-fifth-fifthIcnContainer">
                  <div className="Cn-second-fifthIcn" />
                </div>

                <div className="Cn-third-brandText">捐款者户口</div>
              </div>
            </div>

            <div className="Cn-fifth-iphoneLeft" />
          </div>

          <div className="Cn-thirdContainer">
            <div className="Cn-third-text-Container">
              <div className="Cn-iconWithtext-noDescription">
                <div className="Cn-fifth-fifthIcnContainer2">
                  <div className="Cn-second-sixthIcn" />
                </div>

                <div className="Cn-third-brandText">收集捐款者资料</div>
              </div>
            </div>

            <div className="Cn-fifth-iphoneRight" />
          </div>
          <div className="Cn-thirdContainer">
            <div className="Cn-third-text-Container">
              <div className="Cn-iconWithtext">
                <div className="Cn-receipt-seventhIcnContainer">
                  <div className="Cn-second-seventhIcn" />
                </div>
                <div className="Cn-third-brandText">自动付款及捐款收据处理</div>
              </div>
              <div className="Cn-third-description">
                系统会即时自动处理捐款收据及发送至捐款者所提供的电邮地址。
              </div>
            </div>

            <div className="Cn-receiptSample" />
          </div>
          <div className="Cn-thirdContainer">
            <div className="Cn-reports-features" />
            <div className="Cn-third-text-Container">
              <div className="Cn-iconWithtext">
                <div className="Cn-reports-eighthIcnContainer">
                  <div className="Cn-second-eighthIcn" />
                </div>

                <div className="Cn-third-brandText">自动准备报告</div>
              </div>

              <div className="Cn-third-description">
                机构可以随时输入开始和结束日期请求系统准备报告，系统会准备报告并将报告发送到您的电子邮件。
              </div>
            </div>
          </div>
          <div className="Cn-thirdContainer">
            <div className="Cn-banks">
              <div className="Cn-banksContainer">
                <div className="Cn-bankText">
                  支援所有香港金融管理局持牌银行
                </div>

                <div className="Cn-bankList">
                  <a
                    href="https://www.hsbc.com.hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-hsbc" />
                  </a>

                  <a
                    href="https://www.bochk.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-boc" />
                  </a>

                  <a
                    href="https://www.hangseng.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-hsb" />
                  </a>

                  <a
                    href="https://www.sc.com/hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-sc" />
                  </a>

                  <a
                    href="https://www.icbcasia.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-icbc" />
                  </a>

                  <a
                    href="https://www.citibank.com.hk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-citi" />
                  </a>

                  <a
                    href="https://www.dbs.com.hk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-dbs" />
                  </a>

                  <a
                    href="https://www.hkbea.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-bea" />
                  </a>
                </div>

                <div className="Cn-bankNextContainer">
                  <a
                    href="https://www.hkicl.com.hk/eng/information_centre/clearing_code_and_branch_code_list.php"
                    className="Cn-bankNextText"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    更多银行
                  </a>
                  <div className="Cn-bankNextArrow" />
                </div>
              </div>
            </div>
          </div>
          <div className="Cn-third-space2" />
        </div>

        <div className="Cn-privacy">
          <div className="Cn-privacyContainer">
            <div className="Cn-privacyIcn" />
            <div className="Cn-privacyTxt">私隐</div>
            <div className="Cn-privacyDescription">
              你的数据应该是属于你的。
            </div>
            <Link to="/CnPrivacy">
              <div className="Cn-privacyBtn">
                <div className="Cn-privacyBtnTxt">了解更多</div>
                <div className="Cn-privacyNext" />
              </div>
            </Link>
          </div>
        </div>

        <div className="Cn-tenth">
          <div className="Cn-tenth_container">
            <div className="Cn-tenth-innerContainer">
              <div className="Cn-tenth-text1">
                我们为机构准备了一份资料概要
                PDF，以便您可以进一步了解有关我们的服务。
              </div>
              <div className="Cn-brochureBtn">
                <div className="Cn-brochureBtn-container">
                  <div className="Cn-brochureIcn" />
                  <a
                    href="https://drive.google.com/file/d/1O60Xz6mIkK7jmH5fZvwFlQ6_4v2Fj1YT/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-brochureTxt">下载资料概要 [PDF]</div>
                  </a>
                </div>
              </div>
              <br />
              <div className="Cn-tenth-text1">
                需要更多资料？我们可以跟您一对一见面！
              </div>
              <div className="Cn-meetBtn">
                <div className="Cn-brochureBtn-container">
                  <div className="Cn-meetIcn" />
                  <a
                    href="https://forms.gle/UJ4yasfAtMvqEBeHA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="Cn-brochureTxt">安排会议</div>
                  </a>
                </div>
              </div>
              <br />
              <div className="Cn-tenth-text1">
                如果机构准备好了，请随时注册及建立属于您机构的捐款网页。
              </div>
              <div className="Cn-registerBtn">
                <div className="Cn-registerBtn-container">
                  <div className="Cn-registerIcn" />
                  <Link to="/OrgLogin">
                    <div className="Cn-registerTxt">立即登记</div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="Cn-tenth-iphone" />
          </div>
        </div>

        <div className="Cn-footer">
          <div className="Cn-footerNav">
            <Link to="/CnTeam">
              <div className="Cn-footerNavItem">创办人的故事</div>
            </Link>

            <Link to="/CnFaq">
              <div className="Cn-footerNavItem">常见问题</div>
            </Link>

            <Link to="/CnContact">
              <div className="Cn-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="Cn-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="Cn-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="Cn-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default Cn;
